import React, { Component } from 'react';
import {Row, Col} from 'react-bootstrap'
import {dateTimeFormat} from '../../../utils/commonFunctions'

class OrderSummary extends Component  {
  render () {
    let {attributes} = this.props.order;

    return (
      <div className="order-summary">
        <h4 className='title'>Summary</h4>
        <div>Order number</div>
        <div className="with-margin"><strong>{attributes['order-number']}</strong></div>
        <div>Order date</div>
        <div className="with-margin"><strong>{dateTimeFormat(attributes['order-date'])}</strong></div>
        <div>Your reference</div>
        <div className="with-margin"><strong>{attributes['your-reference']}</strong></div>
        <Row>
          <Col md={8}>
            <div> Total number of items </div>
          </Col>
          <Col md={4}>
            <div className="with-margin"> <strong>{attributes['total-number']}</strong> </div>
          </Col>
        </Row>
        <Row>
          <Col md={8}>
            <div> Total (ex VAT) </div>
          </Col>
          <Col md={4}>
            <div className="with-margin"><strong>€{attributes['total-value'].toFixed(2)}</strong></div>
          </Col>
        </Row>
      </div>
    );
}
}

export default OrderSummary



// WEBPACK FOOTER //
// ./src/components/my-orders/view/order-summary.jsx